import { render, staticRenderFns } from "./enterpriseGoods.vue?vue&type=template&id=95560674&scoped=true&"
import script from "./enterpriseGoods.vue?vue&type=script&lang=js&"
export * from "./enterpriseGoods.vue?vue&type=script&lang=js&"
import style0 from "./enterpriseGoods.vue?vue&type=style&index=0&id=95560674&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95560674",
  null
  
)

export default component.exports